<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="700px"
    :title="curTitle"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="crm-creat-plan-dialog"
  >
    <div class="crm-creat-plan">
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="计划标题" prop="planTitle" class="crm-input-short">
          <el-input v-model="form.planTitle" placeholder="标题不超过10个字" />
        </el-form-item>
        <el-form-item label="计划时间" prop="planTime" class="crm-input-short">
          <div>
            <el-date-picker
              v-model="form.planTime"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              :picker-options="pickerOptions"
            />
          </div>
        </el-form-item>
        <el-form-item label="计划目标" prop="planContent">
          <el-input v-model="form.planContent" type="textarea" placeholder="目标不超过30个字" resize="none" />
        </el-form-item>
        <el-form-item label="选择技能组" prop="skillProperty">
          <el-select
            multiple
            collapse-tags
            v-model="form.skillProperty"
            value-key="type"
            placeholder="请选择技能组"
          >
            <el-option
              v-for="item in skillGroupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="10">
            <el-form-item label="选择客户类型" prop="customerProperty">
              <el-select
                v-model="form.customerProperty"
                value-key="type"
                placeholder="请选择客户类型"
                @change="handleClientTypeChange"
              >
                <el-option
                  v-for="item in inputOptions"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="客户数量" prop="customerTotal" class="crm-input-mini">
              <input
                class="el-input__inner"
                v-model="form.customerTotal"
                placeholder="请输入客户数量"
                @input="handlerInput"
                @blur="handlerBlur"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="优先级" prop="planLevel">
          <el-radio-group v-model="form.planLevel" @change="handleRadioChange">
            <el-radio :label="item.key" v-for="item in priorityList" :key="item.key">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="doCancel">取 消</el-button>
      <el-button type="primary" size="small" @click="doSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCustomerField } from '@/api/crm/clientInfo'
import { creatConnPlan, getSkillGroup, getCustomerCount } from '@/api/crm/plan'

export default {
  components: {},
  props: {
    curCourseId: {
      type: String,
      default: '-1',
      require: true
    }
  },
  data() {
    const validLen = (rule, value, callback) => {
      // 计划标题不能超过10个汉字
      if (!value) {
        return callback(new Error('计划标题不能为空'))
        // return callback()
      } else if (value && this.getByteLen(value.trim()) > 20) {
        callback(new Error('您输入的计划标题过长,请控制在10个字以内'))
      } else {
        callback()
      }
    }
    const validContentLen = (rule, value, callback) => {
      // 计划描述不能超过30个汉字
      if (!value) {
        return callback(new Error('计划描述不能为空'))
        // return callback()
      } else if (value && this.getByteLen(value.trim()) > 60) {
        callback(new Error('您输入的计划描述过长,请控制在30个字以内'))
      } else {
        callback()
      }
    }
    var checkNumber = (rule, value, callback) => {
      if (value === '') {
        callback()
      } else if (Number(value) > this.maxNum) {
        callback(new Error(`客户数量不能大于${this.maxNum}个`))
      } else {
        callback()
      }
    }
    return {
      curTitle: '创建联系计划',
      maxNum: 0,
      dialogVisible: true,
      planForm: {},
      form: { skillProperty: [] },
      inputOptions: [],
      skillGroupList: [],
      planTime: [],
      mould: 3001,
      priorityList: [
        { key: 3, name: '很高' },
        { key: 2, name: '较高' },
        { key: 1, name: '一般' },
        { key: 0, name: '较低' }
      ],
      rules: {
        planTitle: [
          { required: true, validator: validLen, trigger: ['blur', 'change'] }
        ],
        planTime: [
          { required: true, trigger: ['blur', 'change'], message: '请选择日期' }
        ],
        skillProperty: [
          {
            required: true,
            trigger: focus,
            message: '请选择技能组'
          }
        ],
        customerProperty: [
          {
            required: true,
            trigger: ['blur', 'change'],
            message: '请选择客户类型'
          }
        ],
        customerTotal: [
          {
            required: true,
            trigger: ['blur', 'change'],
            message: '请输入客户数量'
          },
          {
            validator: checkNumber,
            trigger: ['blur', 'change']
          }
        ],
        planLevel: [
          {
            required: true,
            trigger: ['blur', 'change'],
            message: '请选择优先级'
          }
        ],
        planContent: [
          {
            required: true,
            validator: validContentLen,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  watch: {
    'form.customerTotal': function(curVal, oldVal) {
      if (!curVal) {
        this.form.customerTotal = ''
        return false
      }
      // 实时把非数字的输入过滤掉
      this.form.customerTotal = curVal.match(/\d/gi)
        ? curVal.match(/\d/gi).join('')
        : ''
    }
  },
  mounted() {
    this.form = {}
    this.getList()
    const option = {
      tag: 'customer_property'
    }
    getCustomerField(option).then(res => {
      this.inputOptions = res.data[0].fieldValues
    })
    getSkillGroup().then(res => {
      this.skillGroupList = res.data
    })
  },
  methods: {
    handlerInput() {
      this.$refs.form.clearValidate('customerTotal')
    },
    handlerBlur() {
      this.$refs.form.validateField('customerTotal')
    },
    getByteLen(val) {
      var len = 0
      for (var i = 0; i < val.length; i++) {
        var a = val.charAt(i)
        // eslint-disable-next-line no-control-regex
        if (a.match(/[^\x00-\xff]/gi) != null) {
          len += 2
        } else {
          len += 1
        }
      }
      return len
    },
    getList() {},
    pickerOptions() {},
    handleClose() {
      this.$emit('closePlanDialog')
    },
    doCancel() {
      this.handleClose()
    },
    handleRadioChange(val) {
      this.form.planLevel = val
    },
    handleClientTypeChange(clientInfo) {
      getCustomerCount(clientInfo).then(res => {
        this.maxNum = res.data
      })
    },
    doSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.planForm = { ...this.form }
          this.planForm.mould = this.mould
          const skillProperty = []
          const skillPropertyId = []
          this.planForm.planStartTime = this.form.planTime[0]
          this.planForm.planEndTime = this.form.planTime[1]
          this.skillGroupList.forEach(item => {
            if (this.form.skillProperty.includes(item.id)) {
              skillProperty.push(item.name)
              skillPropertyId.push(item.id)
            }
          })
          this.planForm.skillProperty = skillProperty.join(',')
          this.planForm.skillPropertyId = skillPropertyId.join(',')
          this.inputOptions.forEach(item => {
            if (this.form.customerProperty === item.id) {
              this.planForm.customerProperty = item.val
              this.planForm.customerPropertyId = item.id
            }
          })
          creatConnPlan(this.planForm).then(res => {
            if (res.code === '2000') {
              this.$message.success('联系计划新增成功')
              this.$emit('closePlanDialog')
              // this.$refs.form.resetFields()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
.crm-creat-plan-dialog {
  .el-dialog .el-dialog__body {
    padding-top: 17px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.crm-creat-plan {
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item {
    margin-bottom: 14px;
  }
  .el-input__inner {
    font-size: 12px;
  }
  .crm-input-short .el-input__inner {
    height: 34px;
    width: 380px;
  }
  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 380px;
  }
  .el-textarea{
    padding-top: 3px;
  }
  .el-textarea__inner {
    font-size: 12px;
    width: 452px;
    height: 48px;
    text-indent: 10;
  }
  .el-select {
    width: 180px;
    .el-input__inner {
      height: 34px;
      line-height: 34px;
    }
  }
  .crm-input-mini .el-input__inner {
    height: 34px;
    width: 180px;
  }
}
</style>
